export const STRING_NOT_TRANSLATED = '__STRING_NOT_TRANSLATED__';
